// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"4a8b4062","401":"5e072bcc","406":"eb557134","621":"aa2921bb"}[chunkId] + ".css";
};